import {  getBaseUrl } from "../../config/api";
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./NuevaVenta.css";
import { User } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import ModalRepresentantesConsult from "./ModalRepresentantesConsult";
import Preloader from "../../components/Preloader";
import { SaleService } from "../../services/SaleService";
import { CategoriaService } from "../../services/CategoriaService";
import { RequisitoService } from "../../services/RequisitoService";
import { DocumentServices } from "../../services/DocumentService";
import { ProductService } from "../../services/ProductService";
import { MarcasService } from "../../services/MarcasService";
import UbicacionVentaConsult from "./UbicacionVentaConsult";

const ConsultarVenta = ({
  token,
  user,
  initialData = {},
  readOnly = false,
  onSave,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [form, setForm] = useState({
    codigoCliente: initialData.codigoCliente || "",
    tipoDocumento: initialData.tipoDocumento || "",
    numeroDocumento: initialData.numeroDocumento || "",
    nombres: initialData.nombres || "",
    apellidoPaterno: initialData.apellidoPaterno || "",
    apellidoMaterno: initialData.apellidoMaterno || "",
    telefonoContacto: initialData.telefonoContacto || "",
    telefonoContacto2: initialData.telefonoContacto2 || "",
    nombresCompletos: initialData.nombresCompletos || "",
    vendedor_id: initialData.vendedor_id || "",
    fecha_venta: initialData.fecha_venta || "",
    nombre_vendedor: initialData.nombre_vendedor || "",
    apellido_vendedor: initialData.apellido_vendedor || "",
    departamento: initialData.departamento || "",
    provincia: initialData.provincia || "",
    distrito: initialData.distrito || "",
    zone: initialData.zone || "",
    direccion: initialData.direccion || "",
    direccionReferencia: initialData.direccionReferencia || "",
    correoElectronico: initialData.correoElectronico || "",
    ventaDetalleId: initialData.ventaDetalleId || "",
    categoriaProducto: initialData.categoriaProducto || "",
    producto: initialData.producto || "",
    precio: initialData.precio || "",
    telefonoMigrar: initialData.telefonoMigrar || "",
    fechaInstalacion: initialData.fechaInstalacion || "",
    amPm: initialData.amPm || "",
    dniFrontal: null,
    dniFrontalPreview: null,
    dniPosterior: null,
    dniPosteriorPreview: null,
    rostroClienteDni: null,
    rostroClienteDniPreview: null,
    frontisCasa: null,
    frontisCasaPreview: null,
    reciboLuz: null,
    reciboLuzPreview: null,
    otrosDocumentos: null,
    otrosDocumentosPreview: null,
  });

  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [requisitos, setRequisitos] = useState([]);
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [fechaFormateada, setFechaFormateada] = useState("");
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [representantes, setRepresentantes] = useState([]);
  const [mostrarModalRepresentantes, setMostrarModalRepresentantes] =
    useState(false);

  const [marca, setMarca] = useState(null);
  const [datosAdicionales, setDatosAdicionales] = useState([]);
  const [loadingMarca, setLoadingMarca] = useState(false);

  const abrirModalRepresentantes = () => setMostrarModalRepresentantes(true);
  const cerrarModalRepresentantes = () => setMostrarModalRepresentantes(false);

  const actualizarRepresentantes = (nuevosRepresentantes) => {
    setRepresentantes(nuevosRepresentantes);
    cerrarModalRepresentantes();
  };

  const handleBackToList = () => {
    navigate("/admin/ventas");
  };

  const fetchMarcaById = async (marcaId) => {
    if (!marcaId) return;
    setLoadingMarca(true);
    try {
      const data = await MarcasService.fetchMarcaPorId({ token, id: marcaId });
      setMarca(data);
    } catch (err) {
      console.error("Error al cargar marca:", err);
    } finally {
      setLoadingMarca(false);
    }
  };

  const fetchVenta = useCallback(async () => {
    setLoading(true);
    try {
      const response = await SaleService.fetchVentaPorId(token, id);

      const ventaData = response.data.venta;
      const clienteData = response.data.cliente;
      const ventaDetallesData = response.data.ventaDetalles;
      const fotosRequisitos = response.data.fotosVenta;
      const ventaDatosAdicionales = response.data.datosAdicionales || [];
      const repData = response.data.clientesRepresentantes || [];
      
      setDatosAdicionales(ventaDatosAdicionales);
      setRepresentantes(repData);
      
      fetchProductos(ventaDetallesData.categoria_id);

      setForm({
        codigoCliente: ventaData.codigo_venta_cliente || "",
        tipoDocumento: String(clienteData.id_tipo_documentos || ""),
        numeroDocumento: clienteData.numero_documento || "",
        nombres: clienteData.nombres || "",
        apellidoPaterno: clienteData.ap_paterno || "",
        apellidoMaterno: clienteData.ap_materno || "",
        telefonoContacto: clienteData.telefono_1 || "",
        telefonoContacto2: clienteData.telefono_2 || "",
        nombresCompletos: clienteData.cliente_razon_social || "",
        vendedor_id: ventaData.id_usuario || "",
        nombre_vendedor: ventaData.nombre_vendedor,
        perfil_vendedor: ventaData.perfil_vendedor,
        apellido_vendedor: ventaData.apellido_vendedor,
        departamento: clienteData.departament_name || "",
        provincia: clienteData.provincia_name || "",
        distrito: clienteData.distrito_name || "",
        zone: clienteData.regiones_name || "",
        direccion: clienteData.direccion || "",
        direccionReferencia: clienteData.direccion_referencia || "",
        correoElectronico: clienteData.email || "",
        latitud: ventaData.latitud_cliente || null,
        longitud: ventaData.longitud_cliente || null,
        categoriaProducto: ventaDetallesData.categoria_id || "",
        ventaDetalleId: ventaDetallesData.id || "",
        producto: ventaDetallesData.id_producto || "",
        precio: ventaDetallesData.precio || "",
        telefonoMigrar: ventaDetallesData.telefono_migrar || "",
        fechaInstalacion: ventaDetallesData.fecha_programacion ? new Date(ventaDetallesData.fecha_programacion).toLocaleDateString('es-PE') : "",
        fecha_venta: ventaData.fecha_venta || "",
        amPm: ventaDetallesData.AM_PM || "",
        dniFrontal: null,
        dniFrontalPreview: null,
        dniPosterior: null,
        dniPosteriorPreview: null,
        rostroClienteDni: null,
        rostroClienteDniPreview: null,
        frontisCasa: null,
        frontisCasaPreview: null,
        reciboLuz: null,
        reciboLuzPreview: null,
        otrosDocumentos: null,
        otrosDocumentosPreview: null,
      });

      const baseUrl = getBaseUrl(); 

      if (ventaDetallesData.id_producto) {
        try {
          const productoData = await ProductService.fetchProductoPorId({ token, id: ventaDetallesData.id_producto });
          if (productoData?.marca_id) {
            await fetchMarcaById(productoData.marca_id);
          }
        } catch (err) {
          console.error("Error al cargar producto para obtener marca:", err);
        }
      }

      const previews = {};
      fotosRequisitos.forEach((foto) => {
        if (!foto.nombre_campo || !foto.nombre_archivo) return;
        const previewField = `${foto.nombre_campo}Preview`;
        const previewFieldNombre = `${foto.nombre_campo}NombreArchivo`;
        previews[previewField] = `${baseUrl}/uploads/${foto.nombre_archivo}`;
        previews[previewFieldNombre] = foto.nombre_archivo;
      });
      setForm((prev) => ({
        ...prev,
        ...previews,
      }));
      const fechaActual = new Date(ventaData.fecha_venta);
      const opcionesFecha = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      setFechaFormateada(
        fechaActual.toLocaleDateString("es-ES", opcionesFecha)
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error al obtener la venta:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, token]);

  const fetchCategorias = useCallback(async () => {
    setLoading(true);
    try {
      const data = await CategoriaService.getCategorias(token);
      setCategorias(data);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchRequisitos = useCallback(async () => {
    try {
      const data = await RequisitoService.fetchRequisitos(token);
      setRequisitos(data);
    } catch (err) {
      console.error("Error al cargar requisitos:", err);
    }
  }, [token]);

  const cargarTipoDocumentos = useCallback(async () => {
    try {
      const tipos = await DocumentServices.getDocuments(token);
      setTiposDocumentos(tipos || []);
    } catch (error) {
      console.error("Error al cargar tipos de Documentos:", error);
    }
  }, [token]);

  useEffect(() => {
    if (id) {
      fetchCategorias();
      fetchRequisitos();
      cargarTipoDocumentos();
      fetchVenta();
    }
  }, [id, token, fetchCategorias, fetchRequisitos, cargarTipoDocumentos, fetchVenta]);

  const fetchProductos = async (value) => {
    if (!value) return;
    setLoading(true);
    try {
      const productos = await ProductService.fetchProductosPorCategoria(token, value);
      setProductos(productos || []);
    } catch (err) {
      console.error("Error al cargar productos:", err);
      setError("Error al cargar los productos.");
    } finally {
      setLoading(false);
    }
  };

  const nextStep = () => {
    if (currentStep < 7) {
      setCurrentStep(currentStep + 1);
      setError("");
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setError("");
    }
  };

  useEffect(() => {
    if (form.categoriaProducto) {
      const productosDeCategoria = productos.filter(
        (producto) => producto.categoria_id === form.categoriaProducto
      );
      setProductosFiltrados(productosDeCategoria);
    }
  }, [form.categoriaProducto, productos]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentStep < 7) {
      nextStep();
      return;
    }
    setLoading(true);
  };

  const renderStep1 = () => {
    let marcaContent;
    if (loadingMarca) {
      marcaContent = <div className="loading">Cargando marca...</div>;
    } else if (marca) {
      const imagenContent = marca.imagen ? (
        <img src={`${getBaseUrl()}/uploads/${marca.imagen}`} alt={marca.descripcion} />
      ) : (
        <div className="marca-consultar-placeholder">
          <span>{marca.descripcion?.charAt(0) || "?"}</span>
        </div>
      );
      marcaContent = (
        <div className="marca-consultar-card">
          {imagenContent}
          <div className="marca-consultar-info">
            <h4>{marca.descripcion}</h4>
          </div>
        </div>
      );
    } else {
      marcaContent = <p className="info-text">No se encontró marca</p>;
    }

    return (
      <div className="form-section">
        <h3 className="section-title">Marca Seleccionada</h3>
        {marcaContent}
      </div>
    );
  };

  const renderStep2 = () => {
    const renderDatoValor = (dato) => {
      if (dato.tipo_campo === "selector" && dato.valores_selector) {
        return JSON.parse(dato.valores_selector).find((v) => v === dato.valor) || dato.valor || "—";
      }
      return dato.valor || "—";
    };

    return (
    <div className="form-section">
      <h3 className="section-title">Datos Adicionales</h3>
      {datosAdicionales.length > 0 ? (
        <div className="datos-adicionales-list">
          {datosAdicionales.map((dato) => (
            <div key={dato.id} className="dato-adicional-item">
              <span className="dato-adicional-label">{dato.nombre_campo}:</span>
              <span className="dato-adicional-value">{renderDatoValor(dato)}</span>
            </div>
          ))}
        </div>
      ) : (
        <p className="info-text">No hay datos adicionales</p>
      )}
    </div>
    );
  };

  const renderStep3 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Cliente</h3>

      <div className="form-grid">
        <div className="">
          <span className="form-label">Código de Cliente</span>
          <p className="info-text">{form.codigoCliente || "—"}</p>
        </div>
        <div className="">
          <span className="form-label">Tipo de Documento *</span>
          <p className="info-text">
            {tiposDocumentos.find((t) => String(t.id) === String(form.tipoDocumento))
              ?.description || "—"}
          </p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <span className="form-label">Número de Documento *</span>
          <div className="input-with-button">
            <p className="info-text">{form.numeroDocumento || "—"}</p>
          </div>
        </div>
        <div className="">
          <span className="form-label">Nombres *</span>
          <p className="info-text">{form.nombres || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <span className="form-label">Apellido Paterno *</span>
          <p className="info-text">{form.apellidoPaterno || "—"}</p>
        </div>
        <div className="">
          <span className="form-label">Apellido Materno</span>
          <p className="info-text">{form.apellidoMaterno || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <span className="form-label">Teléfono de Contacto *</span>
          <p className="info-text">{form.telefonoContacto || "—"}</p>
        </div>
        <div className="">
          <span className="form-label">Nombres Completos / Razón Social</span>
          <div className="input-with-button">
            <p className="info-text">{form.nombresCompletos || "—"}</p>
            {form.tipoDocumento === "4" && (
              <button
                type="button"
                className="contact-btn"
                title="Seleccionar contacto"
                onClick={abrirModalRepresentantes}
              >
                <User size={24} color="white" />
              </button>
            )}
          </div>
          {mostrarModalRepresentantes && (
            <ModalRepresentantesConsult
              clientesSeleccionados={representantes}
              onGuardar={actualizarRepresentantes}
              onCerrar={cerrarModalRepresentantes}
              numero={form.numeroDocumento}
              tipoDocumento={form.tipoDocumento}
              token={token}
            />
          )}
        </div>
      </div>
    </div>
  );

  const renderStep4 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title">Dirección del cliente</h3>

        <div className="form-grid">
          <div>
            <span className="form-label">Departamento</span>
            <p className="info-text">{form.departamento || "—"}</p>
          </div>
          <div>
            <span className="form-label">Provincia</span>
            <p className="info-text">{form.provincia || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div>
            <span className="form-label">Distrito</span>
            <p className="info-text">{form.distrito || "—"}</p>
          </div>
          <div>
            <span className="form-label">Zona</span>
            <p className="info-text">{form.zone || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <span className="form-label">Correo Electrónico</span>
            <p className="info-text">{form.correoElectronico || "—"}</p>
          </div>
          <div className="form-group">
            <span className="form-label">Teléfono de Contacto (Opcional)</span>
            <p className="info-text">{form.telefonoContacto2 || "—"}</p>
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <span className="form-label">Dirección *</span>
            <p className="info-text">{form.direccion || "—"}</p>
          </div>
          <div className="form-group">
            <span className="form-label">Dirección de Referencia</span>
            <p className="info-text">{form.direccionReferencia || "—"}</p>
          </div>
        </div>
      </div>
    );
  };

  const renderStep5 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title">Ubicación en el mapa</h3>
        <p>Verifica la ubicación aproximada del cliente en el mapa:</p>
        <UbicacionVentaConsult form={form} setForm={setForm} />
      </div>
    );
  };

  const renderStep6 = () => {
    const prod = productosFiltrados.find((p) => String(p.id) === String(form.producto));
    return (
    <div className="form-section">
      <h3 className="section-title">Datos del Producto</h3>

      <div className="form-grid">
        <div className="form-group">
          <span className="form-label">Categoría Producto</span>
          <p className="info-text">
            {categorias.find((c) => String(c.id) === String(form.categoriaProducto))?.nombre || "—"}
          </p>
        </div>
        <div className="form-group">
          <span className="form-label">Producto</span>
          <p className="info-text">
            {prod ? `${prod.nombre} - S/ ${prod.precio}` : "—"}
          </p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <span className="form-label">Precio</span>
          <p className="info-text">{form.precio || "—"}</p>
        </div>
        <div className="form-group">
          <span className="form-label">Teléfono a Migrar</span>
          <p className="info-text">{form.telefonoMigrar || "—"}</p>
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <span className="form-label">Fecha de Instalación</span>
          <p className="info-text">{form.fechaInstalacion || "—"}</p>
        </div>
      </div>
    </div>
    );
  };

  const renderStep7 = () => (
    <div className="form-section">
      <h3 className="section-title">📷 Documentos Requeridos</h3>

      <div className="document-grid">
        {requisitos.map((req) => {
          const fieldName = req.nombre_campo;
          const previewField = `${fieldName}Preview`;
          const previewFieldNombre = `${fieldName}NombreArchivo`;
          const isRequired = req.obligatorio === "1";

          const fileName = form?.[previewFieldNombre];
          const previewUrl = form?.[previewField];

          const isPdf =
            typeof fileName === "string" &&
            fileName.toLowerCase().endsWith(".pdf");

          return (
            <div key={req.id} className="document-card">
              <span className="form-label">
                {req.descripcion} {isRequired && "*"}
              </span>

              {previewUrl ? (
                <div className="image-preview">
                  {isPdf ? (
                    <div className="pdf-preview">
                      <span role="img" aria-label="PDF">📄</span>
                      <a
                        href={previewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ver documento
                      </a>
                    </div>
                  ) : (
                    <button type="button" style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }} onClick={() => setPreviewUrl({ url: previewUrl, isPdf: false })}>
                      <img src={previewUrl} alt={req.descripcion} className="preview-image" />
                    </button>
                  )}
                </div>
              ) : (
                <div className="document-icon">
                  {isPdf ? "📄" : "📷"} <span className="no-doc">No cargado</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {previewUrl && (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <div className="preview-modal" onClick={() => setPreviewUrl(null)} onKeyDown={(e) => { if (e.key === 'Escape') setPreviewUrl(null); }}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
            {previewUrl.isPdf ? (
              <iframe
                src={previewUrl.url}
                title="Vista previa PDF"
                width="100%"
                height="600px"
              />
            ) : (
              <img src={previewUrl.url} alt="Vista previa" />
            )}
            <button onClick={() => setPreviewUrl(null)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      case 5:
        return renderStep5();
      case 6:
        return renderStep6();
      case 7:
        return renderStep7();
      default:
        return renderStep1();
    }
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <button type="button" className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Ventas
        </button>
        <span className="breadcrumb-current"> / Consultar Venta</span>
      </div>
      <div className="dashboard-card nuevo-producto-card">
        <span className="nueva-venta-title"> Consultar Venta</span>
        <span className="nueva-venta-subtitle">
          {form.perfil_vendedor} - {form.nombre_vendedor + " " + form.apellido_vendedor}
        </span>
        <span className="nueva-venta-subtitle">
          {fechaFormateada}
        </span>

        <form
          className="nueva-venta-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {renderCurrentStep()}

          {error && <div className="error-message">{error}</div>}

          {!readOnly && (
            <div className="form-actions">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={prevStep}
                  disabled={loading}
                >
                  Anterior
                </button>
              )}
              {currentStep !== 7 && (
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading
                    ? "Procesando..."
                    : "Siguiente"}
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

ConsultarVenta.propTypes = {
  token: PropTypes.string,
  user: PropTypes.object,
  initialData: PropTypes.object,
  readOnly: PropTypes.bool,
  onSave: PropTypes.func,
};

export default ConsultarVenta;
